const normalizeValue = (value) => {
  if (value == null) {
    return undefined;
  }
  const normalized = String(value).trim();
  return normalized === '' ? undefined : normalized;
};

export const getPayerEmail = (payer = {}) =>
  normalizeValue(
    payer.email || payer.person?.email || payer.organization?.email
  );

export const splitLoanAccountNumber = (value) => {
  const normalized = normalizeValue(value);
  if (!normalized) {
    return {};
  }

  const match = normalized.match(/^(.*)-([^-]+)$/);
  if (!match) {
    return { loanNumber: normalized };
  }

  return {
    loanNumber: normalizeValue(match[1]),
    accountSuffix: normalizeValue(match[2]),
  };
};

export const buildEnrolledPalContext = ({
  payer,
  loanNumber,
  accountSuffix,
  email,
} = {}) => {
  const ctx = {
    loanNumber: normalizeValue(loanNumber),
    accountSuffix: normalizeValue(accountSuffix),
    email: normalizeValue(email) || getPayerEmail(payer),
  };

  return Object.entries(ctx).reduce((out, [key, value]) => {
    if (value) {
      out[key] = value;
    }
    return out;
  }, {});
};
